<template>
  <div id="time-line">
    <el-card
      v-show="innerWidthType !== 'xs' && timeData.length"
      class="box-card"
      style="padding: 50px; border-radius: 20px;"
    >
      <el-timeline class="time">
        <el-timeline-item
          v-for="(item, index) in timeData"
          :key="index"
          :timestamp="item.year"
          placement="top"
          :class="index % 2 !== 0 ? 'time-left' : ''"
        >
          <div class="font">{{ item.content }}</div>
          <div
            :style="{
              display: 'flex',
              'justify-content': index % 2 !== 0 ? 'flex-end' : 'flex-start'
            }"
          >
            <el-image
              v-if="item.img"
              class="img"
              style="width: 30%;"
              :src="item.img"
              :preview-src-list="[item.img]"
              lazy
            />
          </div>
        </el-timeline-item>
      </el-timeline>
    </el-card>
  </div>
</template>

<script>
import API from '@/api/service'

export default {
  name: 'TimeLine',
  data() {
    return {
      innerWidthType: '',
      timeData: []
    }
  },
  created() {
    this.getTimeDataList()
  },
  mounted() {
    this.getInnerWidthType()
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
    })
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth > 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
    },
    getTimeDataList() {
      API.getBannerList({ banner_cat_id: 10 }).then(res => {
        res.data.map(item => {
          item.timeSortArr = item.name.match(
            /-?([1-9]\d*(\.\d*)*|0\.[1-9]\d*)/g
          )
          item.timeSort = `${
            item.timeSortArr[0] ? item.timeSortArr[0].padStart(4, '0') : '0000'
          }${item.timeSortArr[1] ? item.timeSortArr[1].padStart(2, '0') : '00'}${
            item.timeSortArr[2] ? item.timeSortArr[2].padStart(2, '0') : '00'
          }`
        })
        res.data = JSON.parse(
          JSON.stringify(
            res.data.sort((a, b) => b.timeSort - a.timeSort)
          )
        )
        const data = []
        res.data.map(item => {
          data.push({
            year: item.name,
            content: item.remark,
            img: item.title === '隐藏图片' ? '' : item.url
          })
        })
        this.timeData = data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#time-line {
  position: relative;
  top: 0;
  left: 0;
  .box-card {
    max-height: 1000px;
    overflow: auto;
    border: none;
    box-shadow: none;
    background: #f2ede7;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
      border-radius: 5px;
      overflow: hidden;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      background: #bd9916;
      border-radius: 5px;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      // background: #EFE8E1;
      // border-radius: 5px;
      // background: linear-gradient(to right, transparent, #EFE8E1, #EFE8E1, #EFE8E1, transparent);
      background: linear-gradient(
        to right,
        #fcf9f2,
        #fcf9f2,
        #efe8e1,
        #fcf9f2,
        #fcf9f2
      );
    }
    .font {
      font-size: 18px;
      line-height: 40px;
      color: #bd9916;
    }
    .img {
      margin-top: 30px;
    }
    .time {
      padding-left: 50%;
      .el-timeline-item {
        padding-left: 10%;
      }
      .time-left {
        /deep/ .el-timeline-item__wrapper {
          left: -110%;
          padding-right: 10%;
          margin-right: 0 !important;
          .el-timeline-item__timestamp {
            text-align: right;
          }
          .el-timeline-item__content {
            text-align: right;
          }
        }
      }
    }
    .time-xs {
      .el-timeline-item {
        padding-left: 10%;
      }
    }
    /deep/ .el-timeline-item__tail {
      border-color: #bd9916;
    }
    /deep/ .el-timeline-item__node {
      background: #bd9916;
    }
    /deep/ .el-timeline-item__wrapper {
      position: relative;
      top: -15px;
      left: 0;
      padding-left: 0;
    }
    /deep/ .el-timeline-item__timestamp {
      font-size: 40px;
      color: #bd9916;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/timeLine.vue